import { render, staticRenderFns } from "./DataView.vue?vue&type=template&id=9a34e6b2&"
import script from "./DataView.vue?vue&type=script&lang=ts&"
export * from "./DataView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports